import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./pros-and-cons.module.css";
import sharedStyles from "../../car-reviews-v2.module.css";
import { SearchButton } from "../search-button";
import { TickWithCircle } from "../assets/tick-with-circle";
import { CrossIcon } from "../assets/cross-icon";
import { EventNames, TrackingEventTypes, useAnalytics } from "@cinch-nx/shared-analytics";
import { createProsAndConsArray } from "./create-pros-and-cons-array";
var ListItem = function(param) {
    var text = param.text, isPro = param.isPro;
    return /*#__PURE__*/ _jsxs("li", {
        className: styles.prosAndConsListItem,
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: isPro ? styles.listItemIconPros : styles.listItemIconCons,
                children: isPro ? /*#__PURE__*/ _jsx(TickWithCircle, {}) : /*#__PURE__*/ _jsx(CrossIcon, {})
            }),
            /*#__PURE__*/ _jsx("span", {
                className: styles.listItemText,
                children: text
            })
        ]
    });
};
export var ProsAndCons = function(param) {
    var prosList = param.prosList, consList = param.consList, make = param.make, model = param.model, areVehiclesInStock = param.areVehiclesInStock;
    var trackEvent = useAnalytics().trackEvent;
    var prosAndConsData = createProsAndConsArray(prosList, consList);
    var handleClick = function() {
        trackEvent({
            eventName: "Car Review - Search for a ".concat(make, " ").concat(model),
            type: TrackingEventTypes.ADOBE,
            data: {
                event: {
                    name: EventNames.click,
                    category: "pros and cons",
                    label: "search for a vehicle",
                    action: make,
                    value: model
                }
            }
        });
    };
    return /*#__PURE__*/ _jsxs("section", {
        className: sharedStyles.inner,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.prosAndConsContainer,
                children: prosAndConsData.map(function(section, index) {
                    return /*#__PURE__*/ _jsxs("div", {
                        className: styles.prosAndConsSection,
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                className: styles.prosAndConsTitle,
                                children: section.title
                            }),
                            /*#__PURE__*/ _jsx("ul", {
                                children: section.body.map(function(item, itemIndex) {
                                    return /*#__PURE__*/ _jsx(ListItem, {
                                        text: item,
                                        isPro: section.title === "Pros"
                                    }, itemIndex);
                                })
                            })
                        ]
                    }, index);
                })
            }),
            areVehiclesInStock && /*#__PURE__*/ _jsx(SearchButton, {
                make: make,
                model: model,
                onClick: function() {
                    return handleClick();
                }
            })
        ]
    });
};
